import { identity } from 'lodash';
import innerText from 'react-innertext';

const csvEscape = (str) => `"${str?.toString().replace(/["]/g, `""`) || ''}"`;

// Converts an array of data into a csv string based on the column
// specifications. Columns can have a displayString, accessor, and format
// function.
export const toCsv = (data, columns) =>
  [
    `${columns
      .map(({ exportDisplayString, displayString }) =>
        csvEscape(exportDisplayString || displayString),
      )
      .join(',')}`,
    ...data.map((row) =>
      columns
        .map(({ accessor, csvFormat: colCsvFormat, format: colFormat }) => {
          const value =
            typeof accessor === 'function' ? accessor(row) : row[accessor];
          const rowCsvFormat = row.csvFormat;
          const rowFormat = row.format;
          const format =
            [rowCsvFormat, rowFormat, colCsvFormat, colFormat].filter(
              (f) => f != null,
            )[0] || identity;
          const formattedValue = format(value, row);
          const stringValue =
            // If the formatted value is an element, render it to a string
            typeof formattedValue === 'object'
              ? innerText(formattedValue)
              : formattedValue;
          return csvEscape(stringValue);
        })
        .join(','),
    ),
  ].join('\n');
